<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="
      entity.value != null
        ? entity.formattedValue
        : 'Feature Made Available By Enabling Map Search Capability'
    "
  />
</div>
